import React, { useRef, useState } from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonLabel,
} from "@ionic/react";
import { useIntl } from "react-intl";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { useSelector } from "react-redux";

const Signature = (props) => {
  const { hideModal, onChangeSignature } = props;
  const [disabled, setDisabled] = useState(true);
  const { activeEmployee } = useSelector((state) => state.employee);
  const intl = useIntl();
  const canvasRef = useRef();
  const onChange = (val) => {
    if (val && val.length > 0) {
      setDisabled(false);
    }
  };
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: `app.mobile.signature`,
            })}
          </IonTitle>
          <IonButtons slot="start">
            <IonButton
              onClick={() => {
                canvasRef.current
                  .exportImage("png")
                  .then((data) => {
                    onChangeSignature(data);
                  })
                  .catch(() => {});

                hideModal();
              }}
              size="default"
              disabled={disabled}
            >
              {intl.formatMessage({
                id: `app.mobile.actions.save`,
              })}
            </IonButton>
          </IonButtons>
          <IonButtons slot="end">
            <IonButton
              onClick={() => {
                hideModal();
              }}
              size="default"
            >
              {intl.formatMessage({
                id: `app.mobile.actions.cancel`,
              })}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ padding: "0 16px" }}>
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.signature_instractions",
            })}
          </IonLabel>
        </div>
        <ReactSketchCanvas
          style={{
            marginRight: window.innerWidth * 0.05,
            border: "1px solid black",
          }}
          ref={canvasRef}
          width={window.innerWidth * 0.9}
          height={(window.innerWidth * 0.9 * 2) / 3}
          strokeWidth={4}
          strokeColor="black"
          onChange={onChange}
        />
        {activeEmployee &&
          activeEmployee.signature &&
          activeEmployee.signature.url && (
            <div
              style={{
                margin: "20px",
                background: "#ffffff",
              }}
            >
              <div
                style={{
                  padding: "4px 16px",
                }}
              >
                <IonLabel>
                  {intl.formatMessage({
                    id: "app.mobile.current_signature",
                  })}
                </IonLabel>
                <img
                  src={activeEmployee.signature.url}
                  alt={"signature"}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          )}
      </IonContent>
    </IonPage>
  );
};

export default Signature;
